import { EventGalleryPanel } from "../../../components/admin/event-hub/EventGalleryPanel";

export function AdminEventGalleryPage() {
  return <EventGalleryPanel />;
}
